import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Home, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import apiService from '../config';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Dashboard from '../Pages/AdminDashboard';
import DashboardRailway from '../Pages/DashboardRailway';
import DashboardHighway from '../Pages/DashboardHighway';
import LandTypeManagement from '../Pages/LandTypeManagement';
import Villagemanagement from '../Pages/VillageManagement';
import MesurementViseObjection from '../Pages/MesurementViseObjection';
import PrivateObjection from '../Pages/PrivateObjection';
import GeneralObjection from '../Pages/GeneralObjection';
import ProjectManagement from '../Pages/ProjectManagement';
import LandholdingList from '../Pages/LandholdingList';
import AddLandholding from '../Pages/AddLandholdingList';
import EditLandholding from '../Pages/EditLandholdinglist';
import CreateProject from '../Pages/CreateProject';
import ObjectionList from '../Pages/ObjectionList';
import Hearing from '../Pages/Hearing';
import MeasurementList from '../Pages/MeasurementList';
import ViewMeasurementList from '../Pages/ViewMeasurementList';
import RoleManagement from '../Pages/RoleManagement';
import ProjectObjection from '../Pages/ProjectObjection';
import AcquisitionRecords from '../Pages/AcquisitionRecords';
import Reports from '../Pages/Reports';
import UserManagement from '../Pages/UserManagement';
// import UserAndRoleManagement from '../Pages/UserAndRoleManagement';
import UserAndRoleManagement from '../Pages/SubUserManagement';
import EditProject from '../Pages/EditProject';
import ReportLandAcquisition from '../Pages/ReportLandAcquisition';
import Section21_1 from '../Pages/Section21_1';
import Section21_1_4 from '../Pages/Section21_1_4';
import UnderSection21 from '../Pages/UnderSection21';
import PrathmikAdhisuchna from '../Pages/PrathmikAdhisuchna';
import Parishtisht1Notice from '../Pages/Parishtisht1Notice';
import OtherDocuments from '../Pages/OtherDocuments';
import LandholdingAllDocu from '../Pages/LandholdingAllDocu';
import KabjaPauti from '../Pages/KabjaPauti';
import Anusuchi2 from '../Pages/Anusuchi2';
import Anusuchi3 from '../Pages/Anusuchi3';
import Anusuchi4 from '../Pages/Anusuchi4';
import Anusuchi5 from '../Pages/Anusuchi5';
import Parishtisht6Notice from '../Pages/Parishtisht6Notice';
import Anusuchi7 from '../Pages/Anusuchi7';
import AreaUnitManagement from '../Pages/AreaUnitManagement';
import Compensation from '../Pages/Compensation';
import CompensationAmount from '../Pages/CompensationAmount';
import Payment from '../Pages/Payment';
import FinalReward from '../Pages/FinalReward';
import SelectFormat from '../Pages/SelectFormat';
import LandAcquisitionCerti from '../Pages/LandAcquisitionCerti';
import ConcernValuer from '../Pages/ConcernValuer';
import Proposal from '../Pages/Proposal'
import PAP from '../Pages/PAP'
import PublishProposal from '../Pages/publishProposal'
import Punavarshan from '../Pages/Punavarshan'
import DirectPayment from '../Pages/DirectPayment'
import NamunaK from '../Pages/Namuna_k';
import ViewProposal from '../Pages/ViewProposal';
import EditProposal from '../Pages/EditProposal';
import Section19 from '../Pages/Section19';
import Section15 from '../Pages/Section15';
import Section15Notice from '../Pages/Section15Notice';
import Section23 from '../Pages/Section23';
import CoveringLetters from '../Pages/CoveringLetters';
import JointMesurmentList from '../Pages/JointMesurmentList';
import MarketValueBail from '../Pages/MarketValueBail';
import MarketValue from '../Pages/MarketValue';
import AdvancePayment from '../Pages/AdvancePayment';
import Section93 from '../Pages/Section93';
import Tehsildar from '../Pages/Tehsildar';
import WorkersJudgment from '../Pages/WorkersJudgment';
import Section21 from '../Pages/Section21';
import FamilySurveyForm from '../Pages/FamilySurveyForm';
import FormC from '../Pages/FormC';
import FundRequestReceived from '../Pages/FundRequestReceived';
import KutumbForm from '../Pages/KutumbForm';
import ExtendedDate from '../Pages/ExtendedDate';
import ExtendedDate19 from '../Pages/ExtendedDate19';
import SearchBar from '../Pages/SearchBar';
import SearchRecords from '../Pages/SearchRecords';
import Namuna_A from '../Pages/DRO/Namuna_A';
import Namuna_B from '../Pages/DRO/Namuna_B';
import Namuna_K from '../Pages/DRO/Namuna_K';
import LandAllocationReport from '../Pages/LandAllocationReport';
import Kalam11 from '../Pages/DRO/Kalam11';
import LandBeneficiary from '../Pages/DRO/LandBeneficiary';
import LandBeneficiaryList from '../Pages/DRO/LandBeneficiaryList';
import LandObjectionRegister from '../Pages/LandObjectionRegister';
import FinalLandAllotmentList from '../Pages/DRO/FinalLandAllotmentList';
import FinalLand from '../Pages/DRO/FinalLand';
import FinalLandAllotmentLetter from '../Pages/DRO/FinalLandAllotmentLetter';
import FinalListofPlot from '../Pages/DRO/FinalListofPlot';
import PrarupList from '../Pages/PrarupList';
import LandBeneficiaryReport from '../Pages/DRO/LandBeneficiaryReport';
import TabaPautiPunarvarshan from '../Pages/DRO/TabaPautiPunarvarshan';
import AkshepNirakaranPrasidhiAheval from '../Pages/DRO/AkshepNirakaranPrasidhiAheval';
import AkshepList from '../Pages/DRO/AkshepList';
import Akshep from '../Pages/DRO/Akshep';
import TabaPautiTippaniLetters from '../Pages/DRO/TabaPautiTippaniLetters';
import PlotAllotmentLetter from '../Pages/DRO/PlotAllotmentLetter';
import AllDocument from '../Pages/AllDocument';
import Notification from '../Pages/Notification';
import ViewDocument from '../Pages/ViewDocument';
import PublicationSection from '../Homepage/PublicationSection';
import ViewProposalDocument from '../Pages/ViewProposalDocument';
import RehabPayment from '../Pages/DRO/RehabPayment';
import PaymentReceipt from '../Pages/DRO/PaymentReceipt';

// For Railway
import RailwayProposal from '../Railway/proposal/RailwayProposal';
import CreateRailwayProposal from '../Railway/proposal/CreateRailwayProposal';
import RailwayLandHoldingList from '../Railway/landholding/RailwayLandHoldingList';
import Namuna_Kh from '../Railway/landholding/notice/Namuna_Kh';
import Other from '../Railway/landholding/notice/Other';
import CreditorList from '../Railway/landholding/notice/CreditorList';
import PrivateLandForm1 from '../Railway/landholding/notice/PrivateLandForm1';
import PrivateLandForm2 from '../Railway/landholding/notice/PrivateLandForm2';
import AcquisitionBoundaryAndArea from '../Railway/landholding/notice/AcquisitionBoundaryAndArea';
import Parishtisht_B from '../Railway/landholding/notice/Parishtisht_B';
import Prastavna from '../Railway/landholding/notice/Prastavna';
import Parishtisht_A from '../Railway/landholding/notice/Parishtisht_A';
import Parishtisht_ASubmissionLetter from '../Railway/landholding/notice/Parishtisht_ASubmissionLetter';
import Annexure_E from '../Railway/landholding/notice/Annexure_E';
import Docu7_12 from '../Railway/landholding/notice/Docu7_12';
import Eight_A from '../Railway/landholding/notice/Eight_A';
import VillageMap from '../Railway/landholding/notice/VillageMap';
import RailwayFundRequestReceived from '../Railway/RailwayFundRequestReceived';
import RailwayPublishProposal from '../Railway/RailwayPublishProposal';
import RailwayPrathmikAdhisuchna from '../Railway/RailwayPrathmikAdhisuchna';
import Railway20ANotification from '../Railway/Railway20ANotification';
import RailwayJointMesurmentList from '../Railway/jmr/RailwayJointMesurmentList';
import RailwayAdvancePayment from '../Railway/RailwayAdvancePayment';
import RailwayObjectionList from '../Railway/objection/RailwayObjectionList';
import RailwayExtendedDate from '../Railway/RailwayExtendedDate';
import RailwaySection19 from '../Railway/RailwaySection19';
import RailwaySection21 from '../Railway/section21/RailwaySection21';
import RailwaySection21_1 from '../Railway/section21/RailwaySection21_1';
import RailwayMarketValue from '../Railway/marketvalue/RailwayMarketValue';
import RailwaySection93 from '../Railway/RailwaySection93';
import RailwayExtendedDate19 from '../Railway/RailwayExtendedDate19';
import RailwaySelectFormat from '../Railway/RailwaySelectFormat';
import RailwayFinalReward from '../Railway/RailwayFinalReward';
import RailwayWorkersJudgment from '../Railway/workersjudgment/RailwayWorkersJudgment';
import RailwayPayment from '../Railway/RailwayPayment';
import RailwayPAP from '../Railway/RailwayPAP';
import RailwayPunavarshan from '../Railway/RailwayPunavarshan';
import RailwaySearchBar from '../Railway/RailwaySearchBar';
//For Highway
import CreateHighwayProposal from '../Highway/proposal/CreateHighwayProposal';
import HighwayProposal from '../Highway/proposal/HighwayProposal';
import EditHighwayProposal from '../Highway/proposal/EditHighwayProposal';
import ViewHighwayProposal from '../Highway/proposal/ViewHighwayProposal';
import HighwayPublishProposal from '../Highway/HighwayPublishProposal';
import SideBarSection3A from '../Highway/SideBarSection3A';
import Cala from '../Highway/Cala';
import HighwayLandHoldingList from '../Highway/landholding/HighwayLandHoldingList';
import SubSection3A from '../Highway/SubSection3A';
import SubShakshepAdhikari from '../Highway/SubShakshepAdhikari';
import HighwayFundRequestReceived from '../Highway/HighwayFundRequestReceived';
import HighwayCoveringLetters from '../Highway/HighwayCoveringLetter';
import HighwayJointMesurmentList from '../Highway/jmr/HighwayJointMesurmentList';
import HighwayAdvancePayment from '../Highway/HighwayAdvancePayment';
import HighwayObjectionList from '../Highway/HighwayObjectionList';
import HighwayExtendedDate from '../Highway/HighwayExtendedDate';
import HighwaySection19 from '../Highway/HighwaySection19';
import HighwayTehsildar from '../Highway/HighwayTehsildar';
import HighwaySection21 from '../Highway/HighwaySection21';
import HighwaySection21_1 from '../Highway/HighwaySection21_1';
import HighwaySection21_1_4 from '../Highway/HighwaySection21_1_4';
import HighwayUnderSection21 from '../Highway/HighwayUnderSection21';
import HighwayMarketValue from '../Highway/HighwayMarketValue';
import HighwayMarketValueBail from '../Highway/HighwayMarketValueBail';
import HighwayDirectPayment from '../Highway/HighwayDirectPayment'
import HighwaySection93 from '../Highway/HighwaySection93';
import HighwayExtendedDate19 from '../Highway/HighwayExtendedDate19';
import HighwaySelectFormat from '../Highway/HighwaySelectFormat';
import HighwayFinalReward from '../Highway/HighwayFinalReward';
import HighwayConcernValuer from '../Highway/HighwayConcernValuer';
import HighwayWorkersJudgment from '../Highway/HighwayWorkersJudgment';
import HighwayPayment from '../Highway/HighwayPayment';
import HighwayPAP from '../Highway/HighwayPAP'
import HighwayPunavarshan from '../Highway/HighwayPunavarshan'
import HighwaySearchBar from '../Highway/HighwaySearchBar';
import HighwayPrathmikAdhisuchna from '../Highway/HighwayPrathmikAdhisuchna';
import HighwayReportLandAcquisition from '../Highway/landholding/reports/HighwayReportLandAcquisition';
import HighwayAnusuchi1 from '../Highway/landholding/reports/HighwayAnusuchi1';
import HighwayAnusuchi2 from '../Highway/landholding/reports/HighwayAnusuchi2';
import HighwayAnusuchi3 from '../Highway/landholding/reports/HighwayAnusuchi3';
import HighwayAnusuchi4 from '../Highway/landholding/reports/HighwayAnusuchi4';
import HighwayAnusuchi5 from '../Highway/landholding/reports/HighwayAnusuchi5';
import HighwayAnusuchi6 from '../Highway/landholding/reports/HighwayAnusuchi6';
import HighwayAnusuchi7 from '../Highway/landholding/reports/HighwayAnusuchi7';
import HighwayOtherDocuments from '../Highway/landholding/reports/HighwayOtherDocuments';
import { ArrowLeft } from "lucide-react";

import { useLanguage } from '../StoreContext/LanguageContext';
import PlotLuckyDraw from '../Pages/DRO/PlotLuckyDraw';
import Section23Final from '../Pages/Section23Final';

export default function Homepage() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [subComponent, setSubComponent] = useState(null);
  const { language, translations } = useLanguage();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [stats] = useState({
    totalProject: 1823,
    totalSectors: 9,
    hectaresTaken: 3,
    totalPayments: 3,
    alreadyDonePayment: 9.36
  });
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProjectName, setCurrentProjectName] = useState(null);
  const [currentStageId, setcurrentStageId] = useState(null);
  const [selectedLandAcquisitionId, setSelectedLandAcquisitionId] = useState(null);
  // Covering Letter
  const [modalParams, setModalParams] = useState(null);
  const [shouldRestoreModal, setShouldRestoreModal] = useState(false);
  const [projectCategory, setProjectCategory] = useState("General");

  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      const user = JSON.parse(userData);
      setUserRole(user.user_role);
    }
  }, []);

  const ROLES = {
    PROJECT_INCHARGE: 18,
    SAMANVAY: 6,
    COLLECTOR: 1,
    LAO: 3,
    DATA_ENTRY: 14
  };

  const getHeadingByRole = (userRole) => {
    if ([ROLES.PROJECT_INCHARGE, ROLES.DATA_ENTRY].includes(userRole)) {
      return translations[language]?.DetailsOfLandToBeAcquire;
    }

    if ([ROLES.COLLECTOR, ROLES.LAO, ROLES.SAMANVAY].includes(userRole)) {
      return translations[language]?.DetailsOfLandToBeAcquirePI;
    }

    return "";
  };

  const handleSetSubComponent = (componentName, landAcquisitionId = null) => {
    setSubComponent(componentName);
    setSelectedLandAcquisitionId(landAcquisitionId);
  };

  const handleBackNavigation = () => {
    // Check which component we're currently on and navigate to appropriate parent
    if (selectedComponent === 'CoveringLetters') {
      // Set flag to restore modal when going back to AcquisitionRecords
      setShouldRestoreModal(false);
      setSelectedComponent('LandholdingList');
    }
    // if (selectedComponent === 'CoveringLetters') {
    //   // Set flag to restore modal when going back to AcquisitionRecords
    //   setShouldRestoreModal(true);
    //   setSelectedComponent('HighwayAddLandHolding');
    // }
    else if (selectedComponent === 'CoveringLettersSection11') {
      setShouldRestoreModal(false);
      setSelectedComponent('PublishProposal');
    }
    else if (selectedComponent === 'CoveringLettersSection19') {
      setShouldRestoreModal(false);
      setSelectedComponent('Section19');
    }
    else if (selectedComponent === 'CoveringLettersSection15') {
      setShouldRestoreModal(false);
      setSelectedComponent('ObjectionList');
    }
    //For Highway

    else if (selectedComponent === 'Cala') {
      setShouldRestoreModal(true);
      setSelectedComponent('SubShakshepAdhikari');
    }
    else if (selectedComponent === 'SideBarSection3A') {
      setShouldRestoreModal(true);
      setSelectedComponent('SubSection3A');
    }
    else if (selectedComponent === 'HighwayCoveringLetters') {
      // Set flag to restore modal when going back to AcquisitionRecords
      setShouldRestoreModal(true);
      setSelectedComponent('HighwayLandholdingList');
    }
    else {
      // For all other components, go back to Dashboard
      setModalParams(null);
      setShouldRestoreModal(false);
      setSelectedComponent('Dashboard');
    }

  };

  // Component names for breadcrumb display
  const componentNames = {
    ProjectManagement: <span>{translations[language].projectmanagement}</span>,
    AllDocument: <span>{translations[language]?.AllDocument || 'All Document'}</span>,
    LandholdingList: <span>{getHeadingByRole(userRole)}</span>,
    AddLandholdingList: <span>{translations[language].AddLandholdingAcquisition}</span>,
    EditLandholdingList: <span>{translations[language].EditLandholdingAcquisition}</span>,
    LandTypeManagement: <span>{translations[language].LandTypeManagement}</span>,
    Villagemanagement: <span>{translations[language].villageManagement}</span>,
    MesurementViseObjection: <span>{translations[language].MeasurementWiseObjection}</span>,
    PrivateObjection: <span>{translations[language].PrivateObjection}</span>,
    GeneralObjection: <span>{translations[language].GeneralObjection}</span>,
    ObjectionList: <span>{translations[language].objectionList}</span>,
    CreateProject: <span>{translations[language].CreateProject}</span>,
    EditProject: <span>{translations[language].EditProject}</span>,
    Hearing: <span>{translations[language].Hearing}</span>,
    GeneralObjectionForm: <span>{translations[language].GeneralObjectionForm}</span>,
    PrivateObjectionForm: <span>{translations[language].PrivateObjectionForm}</span>,
    MeasurementViseObjectionForm: <span>{translations[language].MeasurementWiseObjectionForm}</span>,
    MeasurementList: <span>{translations[language].JointMeasurementList}</span>,
    ViewMeasurementList: <span>{translations[language].JointMeasurementDetails}</span>,
    RoleManagement: <span>{translations[language].roleManagement}</span>,
    AcquisitionRecords: <span>{translations[language].AcquisitionAreaToAcquirableArea}</span>,
    Reports: <span>{translations[language].reports}</span>,
    UserManagement: <span>{translations[language].userManagement}</span>,
    UserAndRoleManagement: <span>{translations[language].UserAndRoleManagement}</span>,
    ReportLandAcquisition: <span>{translations[language].ReportLandAcquisition}</span>,
    Section21_1: <span>{translations[language].Section21_1}</span>,
    Section21: <span>{translations[language].Section21}</span>,
    Section15: <span>{translations[language].Section15}</span>,
    Section15Notice: <span>{translations[language].Section15Notice}</span>,
    LandAcquisitionCerti: <span>{translations[language].LandAcquisitionCerti}</span>,
    PrathmikAdhisuchna: <span>{translations[language].Section11}</span>,
    Parishtisht1Notice: <span>{translations[language].Parishtisht1Notice}</span>,
    OtherDocuments: <span>{translations[language].OtherDocuments}</span>,
    LandholdingAllDocu: <span>{translations[language].AllDocuments}</span>,
    KabjaPauti: <span>{translations[language].KabjaPauti}</span>,
    Anusuchi2: <span>{translations[language].Anusuchi2}</span>,
    Anusuchi3: <span>{translations[language].Anusuchi3}</span>,
    Anusuchi4: <span>{translations[language].Anusuchi4}</span>,
    Anusuchi5: <span>{translations[language].Anusuchi5}</span>,
    Parishtisht6Notice: <span>{translations[language].appendix6}</span>,
    Anusuchi7: <span>{translations[language].Anusuchi7}</span>,
    AreaUnitManagement: <span>{translations[language].AreaUnitManagement}</span>,
    CompensationAmount: <span>{translations[language].CompensationAmount}</span>,
    Compensation: <span>{translations[language].Compensation}</span>,
    Payment: <span>{translations[language].Payment}</span>,
    FinalReward: <span>{translations[language].FinalReward}</span>,
    SelectFormat: <span>{translations[language].selectFormat}</span>,
    ConcernValuer: <span>{translations[language].ConcernValuer}</span>,
    Proposal: <span>{translations[language].Proposal}</span>,
    Namuna_A: <span>{translations[language].namunaA}</span>,
    Namuna_B: <span>{translations[language].namunaB}</span>,
    Namuna_K: <span>{translations[language].namunaK}</span>,
    LandAllocationReport: <span>{translations[language].landAllocationReport}</span>,
    Kalam11: <span>{translations[language].kalam11}</span>,
    LandBeneficiary: <span>{translations[language].landFormatList}</span>,
    LandBeneficiaryList: <span>{translations[language].landBeneficiaryList}</span>,
    FinalLandAllotmentLetter: <span>{translations[language].finalLandAllotmentLetter}</span>,
    PlotAllotmentLetter: <span>{translations[language].PlotAllotmentLetter}</span>,
    LandObjectionRegister: <span>{translations[language].landObjectionRegister}</span>,
    FinalListofPlot: <span>{translations[language].landFinalRemarks}</span>,
    PrarupList: <span>{translations[language].landRemarks}</span>,
    LandBeneficiaryReport: <span>{translations[language].landBeneficiaryReport}</span>,
    TabaPautiPunarvarshan: <span>{translations[language].tabaPautiPunarvarshan}</span>,
    AkshepNirakaranPrasidhiAheval: <span>{translations[language].objectionReport}</span>,
    AkshepList: <span>{translations[language].objectionComments}</span>,
    Akshep: <span>{translations[language].objection}</span>,
    TabaPautiTippaniLetters: <span>{translations[language].tabaPautiTippaniLetters}</span>,
    FinalLandAllotmentList: <span>{translations[language].finalLandAllotmentList}</span>,
    FinalLand: <span>{translations[language].landFinalReport}</span>,
    Notification: <span>Notification</span>,
    PublicationSection: <span>Completed Legacy</span>,
    PublicationSection: <span>Completed Legacy</span>,
    ViewDocument: <span>{translations[language].completedPortel}</span>,
    ViewProposalDocument:<span>ViewProposalDocument</span>,
    RehabPayment:<span>Rehab Payment</span>,
    PaymentReceipt:<span>Payment Receipt</span>,

    //For Railway
    RailwayProposal: <span>{translations[language].railwayProposal}</span>,
    CreateRailwayProposal: <span>{translations[language].createRailwayProposal}</span>,
    EditRailwayProposal: <span>{translations[language].editRailwayProposal}</span>,
    ViewRailwayProposal: <span>{translations[language].viewRailwayProposal}l</span>,
    RailwayLandHoldingList: <span>{translations[language].railwayLandHoldingList}</span>,
    Namuna_Kh: <span>{translations[language].namuna_Kh}</span>,
    Other: <span>{translations[language].other}</span>,
    CreditorList: <span>{translations[language].creditorList}</span>,
    PrivateLandForm1: <span>{translations[language].privateLandForm1}</span>,
    PrivateLandForm2: <span>{translations[language].privateLandForm2}</span>,
    AcquisitionBoundaryAndArea: <span>{translations[language].acquisitionBoundaryAndArea}</span>,
    Parishtisht_B: <span>Parishtisht B</span>,
    Parishtisht_ASubmissionLetter: <span>परिशिष्ट 'अ'</span>,
    Prastavna: <span>{translations[language].introduction}</span>,
    Parishtisht_A: <span>परिशिष्ट "अ"</span>,
    Annexure_E: <span>{translations[language].annexure_E}</span>,
    Docu7_12: <span>{translations[language].docu7_12}</span>,
    Eight_A: <span>{translations[language].eight_A}</span>,
    VillageMap: <span>{translations[language].villageMap}</span>,
    RailwayFundRequestReceived: <span>{translations[language].railwayFundRequest}</span>,
    RailwayPublishProposal: <span>{translations[language].railwayPublishProposal}</span>,
    RailwayPrathmikAdhisuchna: <span>{translations[language].railwayPrathmikAdhisuchna}</span>,
    Railway20ANotification: <span>{translations[language].railway20ANotification}</span>,
    RailwayJointMesurmentList: <span>{translations[language].railwayJointMesurmentList}</span>,
    RailwayAdvancePayment: <span>{translations[language].railwayAdvancePayment}</span>,
    RailwayObjectionList: <span>{translations[language].railwayObjectionList}</span>,
    RailwayExtendedDate: <span>{translations[language].railwayExtendedDate}</span>,
    RailwaySection19: <span>{translations[language].railwaySection19}</span>,
    RailwaySection21: <span>{translations[language].railwaySection21}</span>,
    RailwaySection21_1: <span>{translations[language].railwaySection21_1}</span>,
    RailwayMarketValue: <span>{translations[language].railwayMarketValue}</span>,
    RailwaySection93: <span>{translations[language].railwaySection93}</span>,
    RailwayExtendedDate19: <span>{translations[language].railwayExtendedDate19}</span>,
    RailwaySelectFormat: <span>{translations[language].railwaySelectFormat}</span>,
    RailwayFinalReward: <span>{translations[language].railwayFinalReward}</span>,
    RailwayWorkersJudgment: <span>{translations[language].railwayWorkersJudgment}</span>,
    RailwayPayment: <span>{translations[language].railwayPayment}</span>,
    RailwayPAP: <span>{translations[language].railwayPAP}</span>,
    RailwayPunavarshan: <span>{translations[language].railwayPunavarshan}</span>,
    RailwaySearchBar: <span>{translations[language].railwaySearchBar}</span>,
    //For Highway
    HighwayProposal: <span>{translations[language].highwayProposal}</span>,
    CreateHighwayProposal: <span>{translations[language].createHighwayProposal}</span>,
    EditHighwayProposal: <span>{translations[language].editHighwayProposal}</span>,
    ViewHighwayProposal: <span>{translations[language].viewHighwayProposal}</span>,
    HighwayLandHoldingList: <span>{translations[language].highwayLandHoldingList}</span>,
    HighwayPublishProposal: <span>{translations[language].ProposalPublicationPreliminaryNotification}</span>,
    SideBarSection3A: <span>{translations[language].section3A_Eng}</span>,
    Cala: <span>{translations[language].cala}</span>,
    SubShakshepAdhikari: <span>{'Section 3a'}</span>,
    SubSection3A: <span>{'Section 3A'}</span>,
    HighwayFundRequestReceived: <span>{translations[language].highwayFundRequestReceived}</span>,
    HighwayCoveringLetters: <span>{translations[language].HighwayCoveringLetters}</span>,
    HighwayJointMesurmentList: <span>{translations[language].highwayJointMesurmentList}</span>,
    HighwayAdvancePayment: <span>{translations[language].highwayAdvancePayment}</span>,
    HighwayObjectionList: <span>{translations[language].highwayObjectionList}</span>,
    HighwayExtendedDate: <span>{translations[language].highwayExtendedDate}</span>,
    HighwayCoveringLettersSection19: <span>{translations[language].highwayCoveringLettersSection19}</span>,
    HighwayTehsildar: <span>{translations[language].highwayTehsildar}</span>,
    HighwaySection21_1: <span>{translations[language].highwaySection21_1}</span>,
    HighwaySection21: <span>{translations[language].highwaySection21}</span>,
    HighwaySection21_1_4: <span>{translations[language].highwaySection21_1_4}</span>,
    HighwayUnderSection21: <span>{translations[language].highwayUnderSection21}</span>,
    HighwayMarketValue: <span>{translations[language].highwayMarketValue}</span>,
    HighwayMarketValueBail: <span>{translations[language].highwayMarketValueBail}</span>,
    HighwayDirectPayment: <span>{translations[language].highwayDirectPurchase}</span>,
    HighwaySection93: <span>{translations[language].highwaySection93}</span>,
    HighwayExtendedDate19: <span>{translations[language].highwayExtendedDate19}</span>,
    HighwaySelectFormat: <span>{translations[language].highwaySelectFormat}</span>,
    HighwayConcernValuer: <span>{translations[language].highwayConcernValuer}</span>,
    HighwayWorkersJudgment: <span>{translations[language].highwayWorkersJudgment}</span>,
    HighwayPAP: <span>{translations[language].highwayProjectAffectedPerson}</span>,
    HighwayPunavarshan: <span>{translations[language].highwayPunavarshan}</span>,
    HighwaySearchBar: <span>{translations[language].highwaySearchBar}</span>,
    HighwayPayment: <span>HighwayPayment</span>,
    HighwayPrathmikAdhisuchna: <span>{translations[language].Section11}</span>,
    HighwayReportLandAcquisition: <span>{translations[language].highwayReportLandAcquisition}</span>,
    HighwayAnusuchi1: <span>{translations[language].highwayAnusuchi1}</span>,
    HighwayAnusuchi2: <span>{translations[language].highwayAnusuchi2}</span>,
    HighwayAnusuchi3: <span>{translations[language].highwayAnusuchi3}</span>,
    HighwayAnusuchi4: <span>{translations[language].highwayAnusuchi4}</span>,
    HighwayAnusuchi5: <span>{translations[language].highwayAnusuchi5}</span>,
    HighwayAnusuchi6: <span>{translations[language].highwayAnusuchi6}</span>,
    HighwayAnusuchi7: <span>{translations[language].highwayAnusuchi7}</span>,
    HighwayOtherDocuments: <span>{translations[language].highwayOtherDocuments}</span>,

    PAP: <span>{translations[language].PAP}</span>,
    PublishProposal: <span>{translations[language].ProposalPublicationPreliminaryNotification}</span>,
    Punavarshan: <span>{translations[language].Punavarshan}</span>,
    DirectPayment: <span>{translations[language].DirectPurchase}</span>,
    NamunaK: <span>{translations[language].AddProposal}</span>,
    EditProposal: <span>{translations[language].EditProposal}</span>,
    JointMesurmentList: <span>{translations[language].JointMeasurementList}</span>,
    MarketValueBail: <span>{translations[language].MarketValueBail}</span>,
    MarketValue: <span>{translations[language].MarketValue}</span>,
    AdvancePayment: <span>{translations[language].AdvancePayment}</span>,
    ViewProposal: <span>{translations[language].ViewProposal}</span>,
    Section19: <span>{translations[language].Section19}</span>,
    Section93: <span>{translations[language].Section93}</span>,
    Tehsildar: <span>{translations[language].Tehsilar}</span>,
    Section23: <span>{translations[language].Section23}</span>,
    FamilySurveyForm: <span>{translations[language].FamilySurveyForm}</span>,
    CoveringLetters: <span>{translations[language].CoveringLetters}</span>,
    CoveringLettersSection11: <span>{translations[language].CoveringLettersSection11}</span>,
    CoveringLettersSection19: <span>{translations[language].CoveringLettersSection19}</span>,
    CoveringLettersSection15: <span>{translations[language].CoveringLettersSection15}</span>,
    WorkersJudgment: <span>{translations[language].Workersjudgment}</span>,
    FormC: <span>{translations[language].formSell}</span>,
    FundRequestReceived: <span>{translations[language].FundRequestReceived}</span>,
    Section21_1_4: <span>{translations[language].Section21_1_4}</span>,
    UnderSection21: <span>{translations[language].UnderSection21}</span>,
    ExtendedDate: <span>{translations[language].ExtendedDate11}</span>,
    ExtendedDate19: <span>{translations[language].ExtendedDate19}</span>,
    SearchBar: <span>{translations[language].SearchBar}</span>,
    SearchRecords: <span>{translations[language].searchRecords}</span>,
    KutumbForm: <span>KutumbForm</span>,
  };

  useEffect(() => {
    const getProjectInfo = async () => {
      try {
        const response = await apiService.getProfile();

        if (response.status === 200 && response.data) {
          return {
            id: response.data.default_project,
            name: response.data.default_project_name,
            stage: response.data.stage_no,
          };
        } else {
          console.error('Failed to fetch profile data:', response);
          return { id: null, name: null, stage: null };
        }
      } catch (error) {
        console.error('Error fetching project info:', error);
        return { id: null, name: null, stage: null };
      }
    };

    const updateProjectInfo = async () => {
      const projectInfo = await getProjectInfo();
      setCurrentProjectId(projectInfo.id);
      setCurrentProjectName(projectInfo.name);
      setcurrentStageId(projectInfo.stage);
    };

    updateProjectInfo();
  }, []);

  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name,
            stage: projectData.stage_no || projectData.stage_no,
          };
        } catch (e) {
          console.error('Error parsing current project data:', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name,
            stage: project.stage_no || project.stage_no,
          };
        } catch (e) {
          console.error('Error parsing selected project:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return {
            id: user.data?.project_id || user.project_id,
            name: user.data?.project_name || user.project_name || 'Unknown Project',
            stage: user.data?.stage_no || user.stage_no || 'Stage Not Defined',
          };
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }

      return { id: null, name: null, stage: null };
    };

    const updateProjectInfo = () => {
      const projectInfo = getProjectInfo();
      setCurrentProjectId(projectInfo.id);
      setCurrentProjectName(projectInfo.name);
      setcurrentStageId(projectInfo.stage);
    };

    updateProjectInfo();

    const handleStorageChange = (e) => {
      if (e.key === 'currentProjectData' || e.key === 'selectedProject' || e.key === 'userData') {
        updateProjectInfo();
      }
    };

    const handleCustomStorageChange = () => {
      updateProjectInfo();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('localStorageChange', handleCustomStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageChange', handleCustomStorageChange);
    };
  }, []);

  useEffect(() => {
    const category = localStorage.getItem("project_category");
    setProjectCategory(category);
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      const user = JSON.parse(userData);
      if (user.user_role === null || user.user_role === undefined) {
        navigate('/GeneralObjection');
        return;
      }
    }
  }, [navigate]);

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  useEffect(() => {
    const checkNavigationRequest = () => {
      const goToSubComponent = localStorage.getItem('goToSubComponent');

      if (goToSubComponent === 'DirectPayment') {
        setSelectedComponent('DirectPayment');
        setSubComponent(null);
        localStorage.removeItem('goToSubComponent');
      } else if (goToSubComponent === 'KabjaPauti') {
        setSelectedComponent('KabjaPauti');
        setSubComponent(null);
        localStorage.removeItem('goToSubComponent');
      }
    };

    checkNavigationRequest();
  }, []);


  useEffect(() => {
  }, [selectedComponent, subComponent]);

  const toggleSidebar = () => {
    
    setSidebarOpen(!sidebarOpen);
  };

  // DEBUG: Add console log to navigation handler
  const handleComponentChange = (componentName) => {
    setSelectedComponent(componentName);
    setSubComponent(null);
  };

  // Create component map for rendering
  const componentMap = {
    ProjectManagement: <ProjectManagement onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    AllDocument: <AllDocument onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    LandholdingList:
      <LandholdingList
        setSubComponent={setSubComponent}
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSelectedComponent("Dashboard");
        }}
      />,
    LandTypeManagement: <LandTypeManagement onBack={() => setSelectedComponent(null)} />,
    Villagemanagement: <Villagemanagement onBack={() => setSelectedComponent(null)} />,
    AreaUnitManagement: <AreaUnitManagement onBack={() => setSelectedComponent(null)} />,
    MesurementViseObjection: <MesurementViseObjection onBack={() => setSelectedComponent(null)} />,
    PrivateObjection: <PrivateObjection onBack={() => setSelectedComponent(null)} />,
    GeneralObjection: <GeneralObjection onBack={() => setSelectedComponent(null)} />,
    ObjectionList: <ObjectionList
      setSubComponent={setSubComponent}
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("Dashboard")
      }}
    />,
    PublicationSection: <PublicationSection
      setSubComponent={setSubComponent}
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("Dashboard")
      }}
    />,
    MeasurementList: <MeasurementList
      onBack={() => setSelectedComponent(null)}
      setSubComponent={setSubComponent}
      setSelectedComponent={setSelectedComponent} />,
    RoleManagement: <RoleManagement onBack={() => setSelectedComponent(null)} />,
    AcquisitionRecords: <AcquisitionRecords
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent('Dashboard');
      }}
    />,
    Reports: <Reports onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    UserManagement: <UserManagement onBack={() => setSelectedComponent(null)} />,
    UserAndRoleManagement: <UserAndRoleManagement onBack={() => setSelectedComponent(null)} />,
    CompensationAmount: <CompensationAmount
      onBack={(target) => setSelectedComponent(target || 'Dashboard')} />,
    Payment: <Payment
      onBack={() => setSelectedComponent(null)}
      setSubComponent={setSubComponent} />,
    FinalReward: <FinalReward onBack={(target) => setSelectedComponent(target || 'Dashboard')} setSelectedComponent={setSelectedComponent} setSubComponent={setSubComponent} />,
    SelectFormat: <SelectFormat onBack={(target) => setSelectedComponent(target || 'Dashboard')} setSelectedComponent={setSelectedComponent} setSubComponent={setSubComponent} />,
    ConcernValuer: <ConcernValuer onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Proposal: <Proposal onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} setSelectedComponent={setSelectedComponent} />,
    NamunaK: <NamunaK onBack={() => setSelectedComponent('Proposal')} />,
    PAP: <PAP onBack={() => setSelectedComponent(null)} />,
    JointMesurmentList: <JointMesurmentList onBack={() => setSelectedComponent(null)}
      setSubComponent={setSubComponent} subComponent={subComponent}
      setSelectedComponent={setSelectedComponent} />,
    PublishProposal: <PublishProposal
      setSelectedComponent={setSelectedComponent}
      setSubComponent={setSubComponent}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => setSelectedComponent(null)} />,
    PrathmikAdhisuchna: <PrathmikAdhisuchna
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("PublishProposal")
      }} />,

    Punavarshan: <Punavarshan onBack={() => setSelectedComponent(null)} />,
    ViewProposal: <ViewProposal onBack={() => setSelectedComponent('ViewProposal')} />,
    Section19: <Section19
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent('JointMeasurementList')
      }} />,
    Section15: <Section15
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent('ObjectionList')
      }} />,

    Section93: <Section93 onBack={() => setSelectedComponent(null)} />,
    Tehsildar: <Tehsildar onBack={() => setSelectedComponent('PrathmikAdhisuchna')} />,
    Section15Notice: <Section15Notice onBack={() => setSelectedComponent('ObjectionList')} />,
    TabaPautiTippaniLetters: <TabaPautiTippaniLetters onBack={() => setSelectedComponent('FinalListofPlot')} />,
    TabaPautiTippaniLetters: <TabaPautiTippaniLetters onBack={() => setSelectedComponent('FinalLandAllotmentList')} />,
    TabaPautiTippaniLetters: <TabaPautiTippaniLetters onBack={() => setSelectedComponent('FinalLand')} />,
    Namuna_A: <Namuna_A onBack={() => setSelectedComponent('PlotAllotmentLetter')} />,
    LandBeneficiaryList: <LandBeneficiaryList onBack={() => setSelectedComponent('PrarupList')} />,
    LandBeneficiaryList: <LandBeneficiaryList onBack={() => setSelectedComponent('LandBeneficiaryReport')} />,
    LandAcquisitionCerti: <LandAcquisitionCerti onBack={() => setSelectedComponent('FinalReward')} />,
    Section21_1: <Section21_1 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    DirectPayment: <DirectPayment onBack={() => setSelectedComponent('MarketValueBail')} />,
    Section23: <Section23 onBack={() => setSelectedComponent('FinalReward')}
      setSelectedComponent={setSelectedComponent}
      setSubComponent={setSubComponent} />,
    // Covering Letters
    CoveringLetters: <CoveringLetters
      onBack={() => {
        setShouldRestoreModal(true);
        setSelectedComponent('LandholdingList');
      }}
      modalParams={modalParams}
      moduleType="laoAssign"
      setSelectedComponent={setSelectedComponent}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
    />,
    CoveringLettersSection11: <CoveringLetters
      onBack={() => {
        setShouldRestoreModal(true);
        setSelectedComponent('PublishProposal')
      }}
      modalParams={modalParams}
      moduleType="section11"
      setSelectedComponent={setSelectedComponent}
    />,
    CoveringLettersSection19: <CoveringLetters
      onBack={() => {
        setShouldRestoreModal(false);
        setSelectedComponent('Section19')
      }}
      modalParams={modalParams}
      moduleType="section19"
      setSelectedComponent={setSelectedComponent}
    />,
    CoveringLettersSection15: <CoveringLetters
      onBack={() => {
        setShouldRestoreModal(true);
        setSelectedComponent('ObjectionList')
      }}
      modalParams={modalParams}
      moduleType="section15"
      setSelectedComponent={setSelectedComponent}
    />,
    MarketValueBail: <MarketValueBail onBack={() => setSelectedComponent(null)} setSelectedComponent={setSelectedComponent} />,
    MarketValue: <MarketValue onBack={() => setSelectedComponent(null)} setSelectedComponent={setSelectedComponent} setSubComponent={setSubComponent} />,
    AdvancePayment: <AdvancePayment onBack={() => setSelectedComponent(null)} />,
    WorkersJudgment: <WorkersJudgment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Section21: <Section21 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    FamilySurveyForm: <FamilySurveyForm onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    FundRequestReceived: <FundRequestReceived onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    ExtendedDate: <ExtendedDate onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    ExtendedDate19: <ExtendedDate19 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    SearchBar: <SearchBar onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    SearchRecords: <SearchRecords onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Namuna_A: <Namuna_A onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Namuna_B: <Namuna_B onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Namuna_K: <Namuna_K onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    LandAllocationReport: <LandAllocationReport onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Kalam11: <Kalam11 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    LandBeneficiary: <LandBeneficiary onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    FinalLandAllotmentLetter: <FinalLandAllotmentLetter onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    LandBeneficiaryList: <LandBeneficiaryList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    TabaPautiPunarvarshan: <TabaPautiPunarvarshan onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    LandObjectionRegister: <LandObjectionRegister onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    FinalListofPlot: <FinalListofPlot onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    FinalLandAllotmentList: <FinalLandAllotmentList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    FinalLand: <FinalLand onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    AkshepNirakaranPrasidhiAheval: <AkshepNirakaranPrasidhiAheval onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    AkshepList: <AkshepList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Akshep: <Akshep onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    PrarupList: <PrarupList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    LandBeneficiaryReport: <LandBeneficiaryReport onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    TabaPautiPunarvarshan: <TabaPautiPunarvarshan onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    PlotAllotmentLetter: <PlotAllotmentLetter onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Notification: <Notification onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    ViewDocument: <ViewDocument onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    PublicationSection: <PublicationSection onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RehabPayment: <RehabPayment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,


    // Dashboard: <Dashboard />,
    DashboardRailway: <DashboardRailway />,
    DashboardHighway: <DashboardHighway />,
    //For Railway
    CreateRailwayProposal: <CreateRailwayProposal onBack={() => setSelectedComponent('RailwayProposal')} />,
    RailwayProposal: <RailwayProposal onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayJointMesurmentList: <RailwayJointMesurmentList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayFundRequestReceived: <RailwayFundRequestReceived onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayLandHoldingList: (
      <RailwayLandHoldingList
        onBack={() => setSelectedComponent(null)}
        setSubComponent={setSubComponent}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
        }}
      />
    ),
    RailwayPublishProposal: <RailwayPublishProposal
      setSelectedComponent={setSelectedComponent}
      setSubComponent={setSubComponent} onBack={() => setSelectedComponent(null)} />,
    RailwayPrathmikAdhisuchna: <RailwayPrathmikAdhisuchna
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("RailwayPublishProposal")
      }} />,
    Railway20ANotification: <Railway20ANotification
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("RailwayPublishProposal")
      }} />,
    RailwayAdvancePayment: <RailwayAdvancePayment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayObjectionList: <RailwayObjectionList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayExtendedDate: <RailwayExtendedDate onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwaySection19: <RailwaySection19 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwaySection21: <RailwaySection21 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwaySection21_1: <RailwaySection21_1 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayMarketValue: <RailwayMarketValue onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwaySection93: <RailwaySection93 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayExtendedDate19: <RailwayExtendedDate19 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwaySelectFormat: <RailwaySelectFormat onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayFinalReward: <RailwayFinalReward onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayWorkersJudgment: <RailwayWorkersJudgment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayPayment: <RailwayPayment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayPAP: <RailwayPAP onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwayPunavarshan: <RailwayPunavarshan onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    RailwaySearchBar: <RailwaySearchBar onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,

    //For Highway 

    HighwayObjectionList: <HighwayObjectionList
      setSubComponent={setSubComponent}
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("Dashboard")
      }}
    />,
    HighwayCoveringLetters: <HighwayCoveringLetters
      onBack={() => {
        setShouldRestoreModal(true);
        setSelectedComponent('HighwayLandholdingList');
      }}
      modalParams={modalParams}
      moduleType="laoAssign"
      setSelectedComponent={setSelectedComponent}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
    />,
    SubShakshepAdhikari: <SubShakshepAdhikari
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("Cala")
      }} />,
    SubSection3A: <SubSection3A
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("SideBarSection3A")
      }} />,

    CreateHighwayProposal: <CreateHighwayProposal onBack={() => setSelectedComponent('HighwayProposal')} />,
    HighwayProposal: <HighwayProposal onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} setSelectedComponent={setSelectedComponent} />,
    HighwayLandHoldingList: <HighwayLandHoldingList onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} onNavigateWithModal={(component, params) => {
      setModalParams(params);
      setSelectedComponent(component);
    }} />,

    HighwayPublishProposal: <HighwayPublishProposal
      setSelectedComponent={setSelectedComponent}
      setSubComponent={setSubComponent} onBack={() => setSelectedComponent(null)} />,

    HighwayPrathmikAdhisuchna: <HighwayPrathmikAdhisuchna
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent("HighwayPublishProposal")
      }} />,

    SideBarSection3A: <SideBarSection3A onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    Cala: <Cala onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    SubSection3A: <SubSection3A onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    SubShakshepAdhikari: <SubShakshepAdhikari onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwayFundRequestReceived: <HighwayFundRequestReceived onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwayJointMesurmentList: <HighwayJointMesurmentList onBack={() => setSelectedComponent(null)}
      setSubComponent={setSubComponent} subComponent={subComponent}
      setSelectedComponent={setSelectedComponent} />,
    HighwayAdvancePayment: <HighwayAdvancePayment onBack={() => setSelectedComponent(null)} />,
    HighwayExtendedDate: <HighwayExtendedDate onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwaySection19: <HighwaySection19
      setSelectedComponent={setSelectedComponent}
      modalParams={modalParams}
      shouldRestoreModal={shouldRestoreModal}
      setShouldRestoreModal={setShouldRestoreModal}
      onNavigateWithModal={(component, params) => {
        setModalParams(params);
        setSelectedComponent(component);
      }}
      onBack={() => {
        setModalParams(null);
        setShouldRestoreModal(false);
        setSelectedComponent('HighwayJointMeasurementList')
      }} />,
    HighwayCoveringLettersSection19: <HighwayCoveringLetters
      onBack={() => {
        setShouldRestoreModal(true);
        setSelectedComponent('HighwaySection19')
      }}
      modalParams={modalParams}
      moduleType="HighwaySection19"
      setSelectedComponent={setSelectedComponent}
    />,

    HighwaySection21: <HighwaySection21 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwaySection21_1: <HighwaySection21_1 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwayMarketValue: <HighwayMarketValue onBack={() => setSelectedComponent(null)} setSelectedComponent={setSelectedComponent} setSubComponent={setSubComponent} />,
    HighwayDirectPayment: <HighwayDirectPayment onBack={() => setSelectedComponent('HighwayMarketValueBail')} />,
    HighwaySection93: <HighwaySection93 onBack={() => setSelectedComponent(null)} />,
    HighwayExtendedDate19: <HighwayExtendedDate19 onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwaySelectFormat: <HighwaySelectFormat onBack={(target) => setSelectedComponent(target || 'Dashboard')} setSelectedComponent={setSelectedComponent} setSubComponent={setSubComponent} />,
    HighwayFinalReward: <HighwayFinalReward onBack={(target) => setSelectedComponent(target || 'Dashboard')} setSelectedComponent={setSelectedComponent} setSubComponent={setSubComponent} />,
    HighwayConcernValuer: <HighwayConcernValuer onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwayWorkersJudgment: <HighwayWorkersJudgment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    HighwayPAP: <HighwayPAP onBack={() => setSelectedComponent(null)} />,
    HighwayPunavarshan: <HighwayPunavarshan onBack={() => setSelectedComponent(null)} />,
    HighwaySearchBar: <HighwaySearchBar onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,
    // HighwayTehsildar: <HighwayTehsildar onBack={() => setSelectedComponent('PrathmikAdhisuchna')} />,
    HighwayPayment: <HighwayPayment onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />,

  };

  // Helper function to retrieve stored objection data
  const getStoredObjection = () => {
    try {
      const objectionData = localStorage.getItem('selectedObjection');
      return objectionData ? JSON.parse(objectionData) : null;
    } catch (error) {
      console.error("Error retrieving objection data:", error);
      return null;
    }
  };

  const renderComponent = () => {
    if (subComponent === 'CreateProject') {
      return <CreateProject onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'EditProject') {
      return <EditProject onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'Hearing') {
      return <Hearing
        onBack={() => setSubComponent(null)}
        objection={getStoredObjection()}
      />;
    } else if (subComponent === 'AddLandholdingList') {
      return <AddLandholding onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'CompensationAmount') {
      return <CompensationAmount onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'EditLandholdingList') {
      return <EditLandholding onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'ReportLandAcquisition') {
      return <ReportLandAcquisition onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'KutumbForm') {
    }
    else if (subComponent === 'HighwayReportLandAcquisition') {
      return <HighwayReportLandAcquisition onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi1') {
      return <HighwayAnusuchi1 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi2') {
      return <HighwayAnusuchi2 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi3') {
      return <HighwayAnusuchi3 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi4') {
      return <HighwayAnusuchi4 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi5') {
      return <HighwayAnusuchi5 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi6') {
      return <HighwayAnusuchi6 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayAnusuchi7') {
      return <HighwayAnusuchi7 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayOtherDocuments') {
      return <HighwayOtherDocuments onBack={() => setSubComponent(null)} />;
    }
    // Add this BEFORE the existing `else if (selectedComponent)` at line 1675
    else if (selectedComponent === 'PublicationSection') {
      return <PublicationSection onBack={() => setSelectedComponent(null)} setSubComponent={setSubComponent} />;
    }
    else if (subComponent === 'KutumbForm') {
      return <KutumbForm onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'Parishtisht1Notice') {
      return <Parishtisht1Notice onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'PrathmikAdhisuchna') {
      return <PrathmikAdhisuchna
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
          setSubComponent(null);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSubComponent(null);
        }}
      />;
    } else if (subComponent === 'RailwayPrathmikAdhisuchna') {
      return <RailwayPrathmikAdhisuchna
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
          setSubComponent(null);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSubComponent(null);
        }}
      />;
    } else if (subComponent === 'Railway20ANotification') {
      return <Railway20ANotification
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
          setSubComponent(null);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSubComponent(null);
        }}
      />;
    }
    else if (subComponent === 'HighwayPrathmikAdhisuchna') {
      return <HighwayPrathmikAdhisuchna
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
          setSubComponent(null);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSubComponent(null);
        }}
      />;
    }
    else if (subComponent === 'SubSection3A') {
      return <SubSection3A
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
          setSubComponent(null);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSubComponent(null);
        }}
      />;
    }
    else if (subComponent === 'SubShakshepAdhikari') {
      return <SubShakshepAdhikari
        setSelectedComponent={setSelectedComponent}
        modalParams={modalParams}
        shouldRestoreModal={shouldRestoreModal}
        setShouldRestoreModal={setShouldRestoreModal}
        onNavigateWithModal={(component, params) => {
          setModalParams(params);
          setSelectedComponent(component);
          setSubComponent(null);
        }}
        onBack={() => {
          setModalParams(null);
          setShouldRestoreModal(false);
          setSubComponent(null);
        }}
      />;
    }
    else if (subComponent === 'KabjaPauti') {
      return <KabjaPauti onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'OtherDocuments') {
      return <OtherDocuments onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'LandholdingAllDocu') {
      return <LandholdingAllDocu onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Section21_1_4') {
      return <Section21_1_4 onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'RailwaySection21_1') {
      return <RailwaySection21_1 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'UnderSection21') {
      return <UnderSection21 onBack={() => setSubComponent(Section21_1)} />;
    }
    else if (subComponent === 'Section15Notice') {
      return (
        <Section15Notice
          onBack={() => setSubComponent(null)}
        />
      );
    }
    else if (subComponent === 'TabaPautiTippaniLetters') {
      return (
        <TabaPautiTippaniLetters
          onBack={() => setSubComponent(null)}
        />
      );
    }
    else if (subComponent === 'LandAcquisitionCerti') {
      return (
        <LandAcquisitionCerti
          onBack={() => setSubComponent(null)}
        />
      );
    }
    else if (subComponent === 'Anusuchi2') {
      return <Anusuchi2 onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'Anusuchi3') {
      return <Anusuchi3 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Anusuchi4') {
      return <Anusuchi4 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Anusuchi5') {
      return <Anusuchi5 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Parishtisht6Notice') {
      return <Parishtisht6Notice onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Anusuchi7') {
      return <Anusuchi7 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'ViewProposalDocument') {
      return <ViewProposalDocument onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'PaymentReceipt') {
      return <PaymentReceipt onBack={() => setSubComponent(null)} />;
    }

    //For Railway
    else if (subComponent === 'Namuna_Kh') {
      return <Namuna_Kh onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Other') {
      return <Other onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'CreditorList') {
      return <CreditorList onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'PrivateLandForm1') {
      return <PrivateLandForm1 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'PrivateLandForm2') {
      return <PrivateLandForm2 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'AcquisitionBoundaryAndArea') {
      return <AcquisitionBoundaryAndArea onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Parishtisht_B') {
      return <Parishtisht_B onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Prastavna') {
      return <Prastavna onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Parishtisht_A') {
      return <Parishtisht_A onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Annexure_E') {
      return <Annexure_E onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Eight_A') {
      return <Eight_A onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Docu7_12') {
      return <Docu7_12 onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'VillageMap') {
      return <VillageMap onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Parishtisht_ASubmissionLetter') {
      return <Parishtisht_ASubmissionLetter onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'CreateRailwayProposal') {
      return <CreateRailwayProposal onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'SubSection3A') {
      return <SubSection3A onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'SubShakshepAdhikari') {
      return <SubShakshepAdhikari onBack={() => setSubComponent(null)} />;
    }

    else if (subComponent === 'FormC') {
      return <FormC onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'ViewMeasurementList') {
      return <ViewMeasurementList
        onBack={() => setSubComponent(null)}
        landAcquisitionId={selectedLandAcquisitionId}
      />;
    }
    else if (subComponent === 'GeneralObjectionForm') {
      return <GeneralObjection
        onBack={() => setSubComponent(null)}
        objection={getStoredObjection()}
      />;
    } else if (subComponent === 'PrivateObjectionForm') {
      return <PrivateObjection
        onBack={() => setSubComponent(null)}
        objection={getStoredObjection()}
      />;
    } else if (subComponent === 'MeasurementViseObjectionForm') {
      return <MesurementViseObjection
        onBack={() => setSubComponent(null)}
        objection={getStoredObjection()}
      />;
    } else if (subComponent === 'NamunaK') {
      return <NamunaK onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'FundRequestReceived') {
      return <FundRequestReceived onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'MarketValueBail') {
      return <MarketValueBail onBack={() => setSubComponent(MarketValue)} />;
    }
    else if (subComponent === 'MarketValue') {
      return <MarketValue onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'DirectPayment') {
      return <DirectPayment onBack={() => setSubComponent('MarketValue')} />;
    } else if (subComponent === 'AdvancePayment') {
      return <AdvancePayment onBack={() => setSubComponent(MarketValue)} />;
    } else if (subComponent === 'Section93') {
      return <Section93 onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'Section19') {
    } else if (subComponent === 'Tehsildar') {
      return <Tehsildar onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'Section19') {
      return (
        <Section19
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'Section15') {
      return (
        <Section15
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }

    else if (subComponent === 'FinalListofPlot') {
      return (
        <FinalListofPlot
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'FinalLandAllotmentList') {
      return (
        <FinalLandAllotmentList
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'FinalLand') {
      return (
        <FinalLand
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'AkshepNirakaranPrasidhiAheval') {
      return (
        <AkshepNirakaranPrasidhiAheval
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'AkshepList') {
      return (
        <AkshepList
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'Akshep') {
      return (
        <Akshep
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'PrarupList') {
      return (
        <PrarupList
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'LandBeneficiaryReport') {
      return (
        <LandBeneficiaryReport
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'PlotAllotmentLetter') {
      return (
        <PlotAllotmentLetter
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );

    }
    else if (subComponent === 'Luckydraw') {
      return (
        <PlotLuckyDraw
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );

    }
    else if (subComponent === 'LandBeneficiary') {
      return (
        <LandBeneficiary
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'TabaPautiPunarvarshan') {
      return (
        <TabaPautiPunarvarshan
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    }
    else if (subComponent === 'Section21_1') {
      return <Section21_1 onBack={() => setSubComponent(null)} />;

    } else if (subComponent === 'Section23') {
      return <Section23 onBack={() => setSubComponent(null)} />;
    }
     else if (subComponent === 'Section23Final') {
      return <Section23Final onBack={() => setSubComponent(null)} />;
    }
    // Covering Letters
    else if (subComponent === 'CoveringLetters') {
      return <CoveringLetters onBack={() => setSubComponent(null)} moduleType="laoAssign" />;
    }
    else if (subComponent === 'CoveringLettersSection11') {
      return <CoveringLetters onBack={() => setSubComponent(null)} moduleType="section11" />;
    }
    else if (subComponent === 'CoveringLettersSection19') {
      return <CoveringLetters onBack={() => setSubComponent(null)} moduleType="section19" />;
    }
    else if (subComponent === 'CoveringLettersSection15') {
      return <CoveringLetters onBack={() => setSubComponent(null)} moduleType="section15" />;
    }
    else if (subComponent === 'LandholdingList') {
      return (
        <LandholdingList
          setSubComponent={setSubComponent}
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
          }}
          onBack={() => setSubComponent(null)}
        />
      );
    }
    else if (selectedComponent) {
      if (componentMap[selectedComponent]) {
        if (selectedComponent === 'MeasurementList') {
          return React.cloneElement(componentMap[selectedComponent], {
            setSubComponent: handleSetSubComponent
          });
        }
        return componentMap[selectedComponent];
      } else {
        console.error(`❌ Component "${selectedComponent}" not found in componentMap`);
        return <Dashboard stats={stats} setSelectedComponent={setSelectedComponent} />;
      }
    } else if (subComponent === 'ExtendedDate') {
      return <ExtendedDate onBack={() => setSubComponent(MarketValue)} />;
    } else if (subComponent === 'ExtendedDate19') {
      return <ExtendedDate19 onBack={() => setSubComponent(MarketValue)} />;
    }
    else if (subComponent === 'SearchBar') {
      return <SearchBar onBack={() => setSubComponent(MarketValue)} />;
    }
    else if (subComponent === 'SearchRecords') {
      return <SearchRecords onBack={() => setSubComponent(MarketValue)} />;
    }

    //For Highway
    else if (subComponent === 'CreateHighwayProposal') {
      return <CreateHighwayProposal onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayLandHoldingList') {
      return <HighwayLandHoldingList onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'SideBarSection3A') {
      return <SideBarSection3A onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'Cala') {
      return <Cala onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayProposal') {
      return <HighwayProposal onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayFundRequestReceived') {
      return <HighwayFundRequestReceived onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'HighwayCoveringLetters') {
      return <HighwayCoveringLetters onBack={() => setSubComponent(null)} moduleType="laoAssign" />;
    }
    else if (subComponent === 'HighwayAdvancePayment') {
      return <HighwayAdvancePayment onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'HighwayExtendedDate') {
      return <HighwayExtendedDate onBack={() => setSubComponent(MarketValue)} />;
    } else if (subComponent === 'HighwayCoveringLettersSection19') {
      return <CoveringLetters onBack={() => setSubComponent(null)} moduleType="HighwaySection19" />;
    } else if (subComponent === 'HighwaySection19') {
    } else if (subComponent === 'HighwayTehsildar') {
      return <HighwayTehsildar onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'HighwaySection19') {
      return (
        <HighwaySection19
          setSelectedComponent={setSelectedComponent}
          modalParams={modalParams}
          shouldRestoreModal={shouldRestoreModal}
          setShouldRestoreModal={setShouldRestoreModal}
          onNavigateWithModal={(component, params) => {
            setModalParams(params);
            setSelectedComponent(component);
            setSubComponent(null);
          }}
          onBack={() => {
            setModalParams(null);
            setShouldRestoreModal(false);
            setSubComponent(null);
          }}
        />
      );
    } else if (subComponent === 'HighwaySection21_1_4') {
      return <HighwaySection21_1_4 onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'HighwayUnderSection21') {
      return <HighwayUnderSection21 onBack={() => setSubComponent(HighwaySection21_1)} />;
    } else if (subComponent === 'HighwaySection21_1') {
      return <HighwaySection21_1 onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'HighwayMarketValue') {
      return <HighwayMarketValue onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'HighwayMarketValueBail') {
      return <HighwayMarketValueBail onBack={() => setSubComponent(MarketValue)} />;
    } else if (subComponent === 'HighwaySection93') {
      return <HighwaySection93 onBack={() => setSubComponent(null)} />;
    } else if (subComponent === 'HighwayExtendedDate19') {
      return <HighwayExtendedDate19 onBack={() => setSubComponent(MarketValue)} />;
    } else if (subComponent === 'HighwaySearchBar') {
      return <HighwaySearchBar onBack={() => setSubComponent(MarketValue)} />;
    } else if (selectedComponent) {
      if (componentMap[selectedComponent]) {
        // Add console log here for debugging
        console.log('Rendering component:', selectedComponent);

        if (selectedComponent === 'MeasurementList') {
          return React.cloneElement(componentMap[selectedComponent], {
            setSubComponent: handleSetSubComponent
          });
        }
        return componentMap[selectedComponent];  // This should render AllDocument
      } else {
        console.error(`Component "${selectedComponent}" not found in componentMap`);
        return <Dashboard stats={stats} setSelectedComponent={setSelectedComponent} />;
      }
    }

    else {
      return <Dashboard stats={stats} setSelectedComponent={setSelectedComponent} />;
    }


  };

  const getPageTitle = () => {
    if (subComponent === 'GeneralObjectionForm' ||
      subComponent === 'PrivateObjectionForm' ||
      subComponent === 'MeasurementViseObjectionForm' ||
      subComponent === 'Hearing') {
      return componentNames.ObjectionList;
    } else if (subComponent === 'AddLandholdingList' || subComponent === 'EditLandholdingList') {
      return componentNames.LandholdingList;
    } else if (subComponent === 'CreateProject' || subComponent === 'EditProject') {
      return componentNames.ProjectManagement;
    } else if (subComponent === 'ViewMeasurementList') {
      return componentNames.MeasurementList;
    } else if (subComponent === 'Compensation') {
      return componentNames.CompensationAmount;
    } else if (subComponent) {
      return componentNames[subComponent] || subComponent;
    } else if (selectedComponent) {
      return componentNames[selectedComponent] || selectedComponent;
    } else if (subComponent === 'LandholdingList') {
      return 'Proposal';
    }
  };

  const getParentComponent = () => {
    if (subComponent === 'GeneralObjectionForm' ||
      subComponent === 'PrivateObjectionForm' ||
      subComponent === 'MeasurementViseObjectionForm' ||
      subComponent === 'Hearing') {
      return 'ObjectionList';
    } else if (subComponent === 'AddLandholdingList' || subComponent === 'EditLandholdingList') {
      return 'LandholdingList';
    } else if (subComponent === 'CreateProject' || subComponent === 'EditProject') {
      return 'ProjectManagement';
    } else if (subComponent === 'ViewMeasurementList') {
      return 'MeasurementList';
    }
    else if (subComponent === 'ReportlandAcquisition') {
      return 'LandholdingList';
    }

    else if (subComponent === 'Section21_1') {
      return 'Section21';
    } else if (subComponent === 'Section21_1_4') {
      return 'Section21';
    } else if (subComponent === 'UnderSection21') {
      return 'Section21';
    } else if (subComponent === 'RailwaySection21_1') {
      return 'RailwaySection21';
    } else if (subComponent === 'Parishtisht1Notice') {
      return 'LandholdingList';
    } else if (subComponent === 'KutumbForm') {
      return 'FamilySurveyForm';
    }
    else if (subComponent === 'OtherDocuments') {
      return 'LandholdingList';
    }
    else if (subComponent === 'LandholdingAllDocu') {
      return 'LandholdingList';
    }
    else if (subComponent === 'FormC') {
      return 'WorkersJudgment';
    }
    else if (subComponent === 'KabjaPauti') {
      return 'WorkersJudgment';
    }
    else if (subComponent === 'LandAcquisitionCerti') {
      return 'WorkersJudgment';
    }
    else if (subComponent === 'Anusuchi2') {
      return 'LandholdingList';
    } else if (subComponent === 'Anusuchi3') {
      return 'LandholdingList';
    } else if (subComponent === 'Anusuchi4') {
      return 'LandholdingList';
    } else if (subComponent === 'Anusuchi5') {
      return 'LandholdingList';
    }else if (subComponent === 'ViewProposalDocument') {
      return 'LandholdingList';
    } else if (subComponent === 'Parishtisht6Notice') {
      return 'LandholdingList';
    } else if (subComponent === 'Anusuchi7') {
      return 'LandholdingList';
    }
     else if (subComponent === 'PaymentReceipt') {
      return 'RehabPayment';
    }
    //For Railway
    else if (subComponent === 'Namuna_Kh') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Other') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'CreditorList') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'PrivateLandForm1') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'PrivateLandForm2') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'AcquisitionBoundaryAndArea') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Parishtisht_B') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Prastavna') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Annexure_E') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Docu7_12') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Eight_A') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'VillageMap') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Parishtisht_A') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'Parishtisht_ASubmissionLetter') {
      return 'RailwayLandHoldingList';
    }
    else if (subComponent === 'EditProposal') {
      return 'LandholdingList';
    }
    else if (subComponent === 'Compensation') {
      return 'CompensationAmount';
    } else if (subComponent === 'PrathmikAdhisuchna') {
      return 'PublishProposal';
    } else if (subComponent === 'Section23') {
      return 'FinalReward';
    } else if (subComponent === 'RailwayPrathmikAdhisuchna') {
      return 'RailwayPublishProposal';
    } else if (subComponent === 'Railway20ANotification') {
      return 'RailwayPublishProposal';
    }
    // Covering Letters
    else if (subComponent === 'CoveringLetters') {
      return 'AcquisitionRecords';
    }
    else if (subComponent === 'CoveringLettersSection11') {
      return 'PublishProposal';
    }
    else if (subComponent === 'CoveringLettersSection19') {
      return 'Section19';
    }
    else if (subComponent === 'CoveringLettersSection15') {
      return 'ObjectionList';
    }
    else if (subComponent === 'Section19') {
      return 'JointMesurmentList';
    }
    else if (subComponent === 'MarketValue') {
      return 'MarketValue';
    }
    else if (subComponent === 'MarketValueBail') {
      return 'MarketValue';
    }
    else if (subComponent === 'DirectPayment') {
      return 'MarketValue';
    }
    else if (subComponent === 'FamilySurveyForm') {
      return <FamilySurveyForm onBack={() => setSubComponent(null)} />;
    }
    else if (subComponent === 'AdvancePayment') {
      return 'AdvancePayment';
    }

    //For Highway
    // else if (subComponent === 'HighwayPublishProposal') {
    //   return 'Section3A';
    // }
    else if (subComponent === 'HighwayReportLandAcquisition') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi1') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi2') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi3') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi4') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi5') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi6') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayAnusuchi7') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'HighwayOtherDocuments') {
      return 'HighwayLandHoldingList';
    }
    else if (subComponent === 'Section19') {
      return 'HighwayJointMesurmentList';
    } else if (subComponent === 'HighwayAdvancePayment') {
      return 'HighwayAdvancePayment';
    } else if (subComponent === 'CoveringLettersSection15') {
      return 'HighwayObjectionList';
    } else if (subComponent === 'HighwayCoveringLettersSection19') {
      return 'HighwaySection19';
    } else if (subComponent === 'HighwaySection21_1') {
      return 'HighwaySection21';
    } else if (subComponent === 'HighwaySection21_1_4') {
      return 'HighwaySection21';
    } else if (subComponent === 'HighwayUnderSection21') {
      return 'HighwaySection21';
    } else if (subComponent === 'HighwayMarketValue') {
      return 'HighwayMarketValue';
    }
    else if (subComponent === 'HighwayPrathmikAdhisuchna') {
      return 'HighwayPublishProposal';
    }
    else if (subComponent === 'HighwayMarketValueBail') {
      return 'HighwayMarketValue';
    }
    else if (subComponent === 'HighwayDirectPayment') {
      return 'HighwayMarketValue';
    } else if (subComponent === 'HighwaySection23') {
      return 'HighwayFinalReward';
    } else if (subComponent === 'HighwayFormC') {
      return 'HighwayWorkersJudgment';
    } else if (subComponent === 'HighwayKabjaPauti') {
      return 'HighwayWorkersJudgment';
    } else if (subComponent === 'HighwayLandAcquisitionCerti') {
      return 'HighwayWorkersJudgment';
    }
    else if (subComponent === 'LandAcquisitionCerti') {
      return (
        <LandAcquisitionCerti
          onBack={() => setSubComponent(null)}
        />
      );
    }

    return null;
  };

  return (
    <div className="h-screen overflow-hidden flex flex-col bg-blue-100">
      <div className="flex flex-1 overflow-hidden">
        <div className="flex-shrink-0">
          <Sidebar
            isOpen={sidebarOpen}
            setSelectedComponent={handleComponentChange}
            currentComponent={selectedComponent}
          />
        </div>
        <div className={`flex-1 transition-all duration-300 min-w-0 flex flex-col overflow-hidden ${sidebarOpen ? "ml-64" : "ml-0"}`}>
          <Navbar toggleSidebar={toggleSidebar} hideProposalInfo={selectedComponent === null || selectedComponent === 'Dashboard'} />
          <div className="flex-1 flex flex-col overflow-hidden">
            <div className="bg-white shadow-sm px-6 py-2 flex items-center flex-shrink-0">
              <button
                className="text-blue-600 hover:text-blue-900 flex items-center gap-2"
                onClick={() => {
                  setSelectedComponent(null);
                  setSubComponent(null);
                }}
              >
                {selectedComponent && selectedComponent !== 'Dashboard' ? (
                  <>
                    <Home size={16} />
                    <span className="text-sm font-semibold text-gray-800">
                      {currentProjectName}
                    </span>
                  </>
                ) : null}


              </button>

              {(selectedComponent || getParentComponent()) && (
                <>
                  <ChevronRight size={16} className="mx-2 text-gray-400" />
                  <button
                    className="text-blue-600 hover:text-blue-900"
                    onClick={() => {
                      const parent = getParentComponent();
                      if (parent && subComponent) {
                        setSelectedComponent(parent);
                        setSubComponent(null);
                      } else {
                        setSubComponent(null);
                      }
                    }}
                  >
                    {componentNames[getParentComponent() || selectedComponent] || getParentComponent() || selectedComponent}
                  </button>
                </>
              )}

              {subComponent && (
                <>
                  <ChevronRight size={16} className="mx-2 text-gray-400" />
                  <span className="text-gray-700 font-medium">
                    {componentNames[subComponent] || subComponent}

                  </span>
                </>
              )}
            </div>

            <motion.div
              className="flex-1 overflow-y-auto p-6"
              initial={{ opacity: 0 }}
              animate={{ opacity: pageLoaded ? 1 : 0 }}
              transition={{ duration: 0.5 }}
              key={`${selectedComponent}-${subComponent}`}
            >
              {selectedComponent || subComponent ? (
                <motion.div
                  className="w-full bg-white rounded-lg shadow-md "
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="bg-gradient-to-r from-blue-900 to-blue-900 p-4 text-white flex justify-between items-center">
                    <h2 className="text-2xl font-bold text-white-900 mb-3">
                      {getPageTitle()}
                    </h2>
                    <button
                      onClick={() => {
                        if (subComponent) {
                          setSubComponent(null);
                        } else if (handleBackNavigation) {
                          handleBackNavigation();
                        } else {
                          setSelectedComponent(null);
                        }
                      }}
                      className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg px-3 py-1 flex items-center gap-2 transition-all duration-200"
                    >
                      <ArrowLeft size={20} />
                      <span className="font-medium">{translations[language]?.back || 'Back'}</span>
                    </button>
                  </div>
                  <div className="p-4">
                    {renderComponent()}
                  </div>
                </motion.div>
              ) : (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <Dashboard stats={stats} setSelectedComponent={setSelectedComponent} />
                </motion.div>
              )}
            </motion.div>

            {/* <div className="flex-shrink-0">
              <Footer />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
